module.exports = __webpack_public_path__ + "img/chr_ts_5_penlight.1a9077e2.png";